import Vue from 'vue';
import VueMatomo from 'vue-matomo';

export default (router) => {
    const host = process.env.VUE_APP_TRACKING_HOST;
    const siteId = process.env.VUE_APP_TRACKING_SITE_ID;

    // Do not set up tracking if the config is missing
    if (!host || !siteId) {
        return;
    }

    Vue.use(VueMatomo, {
        // Configure your matomo server and site by providing
        host,
        siteId,

        // Enables automatically registering pageviews on the router
        router: router,

        // Require consent before sending tracking information to matomo
        requireConsent: true,
    });
};
